import { render, staticRenderFns } from "./DetailEncargoCompForm.vue?vue&type=template&id=c34b61c0&scoped=true&"
import script from "./DetailEncargoCompForm.vue?vue&type=script&lang=js&"
export * from "./DetailEncargoCompForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34b61c0",
  null
  
)

/* custom blocks */
import block0 from "./DetailEncargoCompForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
